<template>
  <div class="bhist-page">
    <div class="bhist-inner">
      <section class="bhist-card bhist-card--header" aria-label="Betslip history">
        <h1 class="bhist-title">
          {{
            $store.state.language === 'en'
              ? 'Betslip History'
              : 'ဘောက်ချာများ'
          }}
        </h1>
        <div class="bhist-segments" role="tablist">
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === 'twod' }"
            @click="changeType('twod'); fetchHistory()"
          >
            {{
              $store.state.language === 'en'
                ? '2D'
                : 'နှစ်လုံး'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === 'threed' }"
            @click="changeType('threed'); fetchHistory()"
          >
            {{
              $store.state.language === 'en'
                ? '3D'
                : 'သုံးလုံး'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === 'maung' }"
            @click="changeType('maung'); fetchHistory()"
          >
            {{
              $store.state.language === 'en'
                ? 'Maung'
                : 'မောင်း'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === 'body' }"
            @click="changeType('body'); fetchHistory()"
          >
            {{
              $store.state.language === 'en'
                ? 'Body'
                : 'ဘော်ဒီ'
            }}
          </button>
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === '1x2' }"
            @click="changeType('1x2'); fetchHistory()"
          >
            1x2
          </button>
          <button
            type="button"
            role="tab"
            class="bhist-seg"
            :class="{ 'bhist-seg--active': type === 'correctScore' }"
            @click="changeType('correctScore'); fetchHistory()"
          >
            {{
              $store.state.language === 'en'
                ? 'Correct Score'
                : 'Correct Score'
            }}
          </button>
        </div>

        <div class="bhist-filters">
          <div class="bhist-filters-row">
            <div
              v-if="type === 'twod'"
              class="bhist-select-wrap bhist-select-wrap--draw"
            >
              <TwoDSelect
                type="draw"
                :data="params"
                field="draw"
              />
            </div>
            <div
              v-if="type !== 'threed'"
              class="bhist-select-wrap"
            >
              <v-select
                v-model="params.date"
                :reduce="(draw) => draw.data"
                label="label"
                :options="dateOptions"
                class="bhist-select"
              />
            </div>
            <div
              v-if="type === 'threed'"
              class="bhist-draw-field"
            >
              <span class="bhist-draw-label">{{
                $store.state.language === 'en' ? 'Draw' : 'အကြိမ်'
              }}</span>
              <v-select
                v-model="params.date"
                :reduce="(draw) => draw.data"
                label="label"
                :options="dateOptionsThreed"
                class="bhist-select"
              />
            </div>
            <button
              type="button"
              class="bhist-search"
              @click="fetchHistory"
            >
              {{
                $store.state.language === 'en'
                  ? 'Search'
                  : 'ရှာမည်'
              }}
            </button>
          </div>
          <div
            v-if="type === 'twod' || type === 'threed'"
            class="bhist-bingo"
          >
            <b-form-checkbox
              v-model="isBingo"
              size="lg"
              class="bhist-bingo__check"
              @change="fetchHistory()"
            />
            <span class="bhist-bingo__label">{{
              $store.state.language === 'en'
                ? 'Bingo?'
                : 'ပေါက်ဂဏန်းပါ'
            }}</span>
          </div>
        </div>
      </section>

      <section class="bhist-card bhist-card--table" aria-label="Results">
        <div class="bhist-table-wrap">
          <div v-if="isSearch" class="bhist-loading">
            <Loading
              color="#5c98ff"
              size="28"
              class="bhist-loading__spin"
            />
            <span class="bhist-loading__text">{{
              $store.state.language === 'en'
                ? 'Loading…'
                : 'ခဏစောင့်ပါ…'
            }}</span>
          </div>
          <div
            v-else-if="!betHistoryList.length"
            class="bhist-empty"
          >
            {{
              $store.state.language === 'en'
                ? 'No betslips for this filter.'
                : 'ဤရွေးချယ်မှုအတွက် ဘောက်ချာ မရှိပါ။'
            }}
          </div>
          <table
            v-else
            class="table align-items-center table-flush bhist-table"
          >
            <thead class="thead-light">
              <tr>
                <th>
                  <div class="d-flex">
                    <div class="mx-auto">
                      {{
                        $store.state.language === 'en'
                          ? 'Voucher Id'
                          : 'ဘောက်ချာနံပါတ်'
                      }}
                    </div>
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <div class="mx-auto">
                      {{
                        $store.state.language === 'en'
                          ? 'Remark'
                          : 'မှတ်ချက်'
                      }}
                    </div>
                  </div>
                </th>
                <th v-if="isBingo">
                  <div class="d-flex">
                    <div class="mx-auto">
                      {{
                        $store.state.language === 'en'
                          ? 'Bingo Amount'
                          : 'ပေါက်ဂဏန်း ပမာဏ'
                      }}
                    </div>
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <div class="mx-auto">
                      {{
                        $store.state.language === 'en'
                          ? 'Total Amount'
                          : 'စုစုပေါင်း'
                      }}
                    </div>
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <div class="mx-auto">
                      {{
                        $store.state.language === 'en'
                          ? 'Bet Date'
                          : 'ထိုးသည့်နေ့စွဲ'
                      }}
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="list">
              <tr
                v-for="(history, index) in betHistoryList"
                :key="index"
                class="bhist-row"
                @click="getSlipdata(history)"
              >
                <th scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-cell-muted">{{
                      history.voucher_id
                    }}</span>
                  </div>
                </th>
                <th scope="row">
                  <div class="media d-flex">
                    <span
                      v-if="!history.isBet"
                      class="mx-auto mb-0 badge badge-danger"
                    >
                      {{
                        $store.state.language === 'en'
                          ? 'Incomplete'
                          : 'မပြီးစီး'
                      }}
                    </span>
                    <span
                      v-else-if="history.bingo_amount > 0 || history.is_bingo"
                      class="mx-auto mb-0 text-md"
                    >
                      <i class="fas fa-check text-success pr-0" />
                    </span>
                    <span
                      v-else
                      class="mx-auto mb-0 text-md"
                    >
                      <i class="fas fa-times text-danger" />
                    </span>
                  </div>
                </th>
                <th v-if="isBingo" scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-cell-muted">{{
                      history.bingo_amount
                    }}</span>
                  </div>
                </th>
                <th scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-cell-muted">{{
                      history.total_amount
                    }}</span>
                  </div>
                </th>
                <th scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-cell-muted">{{
                      betDate(history.created_at)
                    }}</span>
                  </div>
                </th>
              </tr>
              <tr class="bhist-totals-row">
                <th scope="row" />
                <th scope="row" />
                <th v-if="isBingo" scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-total-label">
                      {{ $store.state.language === 'en' ? 'Total' : 'စုစုပေါင်း' }}
                      —
                      <b class="bhist-total-bingo">{{
                        Number(totalBingoAmount()).toLocaleString()
                      }}</b>
                    </span>
                  </div>
                </th>
                <th scope="row">
                  <div class="media d-flex">
                    <span class="mx-auto mb-0 text-md bhist-total-label">
                      {{ $store.state.language === 'en' ? 'Total' : 'စုစုပေါင်း' }}
                      —
                      <b class="bhist-total-amt">{{
                        Number(totalVoucherAmount()).toLocaleString()
                      }}</b>
                    </span>
                  </div>
                </th>
                <th />
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="col-4 p-0" ref="captureElement">
      <div
        id="voucher-history"
        class="modal fade bhist-voucher-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="bhist-voucher-title"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered bhist-modal-dialog"
          role="document"
        >
          <div class="modal-content bhist-modal-content">
            <div class="bhist-modal-toolbar">
              <button
                type="button"
                class="bhist-modal-capture"
                :aria-label="$store.state.language === 'en' ? 'Save screenshot' : 'ဓာတ်ပုံ သိမ်းမည်'"
                @click="captureThisVoucher()"
              >
                <i class="fas fa-camera" />
                <span class="bhist-modal-capture-label">{{
                  $store.state.language === 'en' ? 'Save' : 'သိမ်းမည်'
                }}</span>
              </button>
              <h2
                id="bhist-voucher-title"
                class="bhist-modal-title"
              >
                {{
                  $store.state.language === 'en' ? 'Voucher' : 'ဘောက်ချာ'
                }}
              </h2>
              <button
                type="button"
                class="bhist-modal-close"
                :aria-label="$store.state.language === 'en' ? 'Close' : 'ပိတ်မည်'"
                @click="closeModal"
              >
                ×
              </button>
            </div>
            <div
              v-if="type === 'maung' || type === 'body' || type === '1x2' || type === 'correctScore'"
              id="capture"
              class="modal-body p-0 bhist-modal-body"
            >
              <FBVoucher
                :type="type"
                :datas="datas"
                :slipId="slipId"
                :currentTime="bet_date"
                :isHistory="true"
                :is_result="is_result"
                :bingo_amount="bingo_amount"
              />
            </div>
            <div
              v-else
              id="capture"
              class="modal-body p-0 bhist-modal-body"
            >
              <Voucher
                type="history"
                :datas="datas"
                :slipId="slipId"
                :currentTime="bet_date"
                :isTwod="isTwod"
                :name="name"
                :remark="remark"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Voucher from './components/Voucher.vue';
import { DateTime } from 'luxon';
import { Loading, Dialog, Toast } from 'vant';
import FBVoucher from './components/FBVoucher.vue';
import html2canvas from 'html2canvas';
import { mapActions } from 'vuex';
import TwoDSelect from './components/TwoDSelect.vue';

export default {
  components: {
    TwoDSelect,
    Voucher,
    Loading,
    FBVoucher,
  },
  data() {
    return {
      isSearch: false,
      isBingo: false,
      type: 'twod',
      remark: '',
      name: '',
      searchKeyword: '',
      params: {
        draw: '',
        date: '',
      },
      dateOptionsThreed: [
        {
          label: null,
          data: null,
        },
        {
          label: null,
          data: null,
        },
      ],
      dateOptions: [],
      betHistory: [],
      datas: [],
      slipId: null,
      bet_date: null,
      isTwod: true,
      bingo_amount: null,
      is_result: false,
    };
  },
  computed: {
    betHistoryList() {
      return Array.isArray(this.betHistory) ? this.betHistory : [];
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    async captureThisVoucher() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to take screenshot?'
            : 'ဓာတ်ပုံအနေဖြင့် သိမ်းမှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မသိမ်းတော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      }).then(async () => {
        await this.captureElement();
        Toast.success(
          this.$store.state.language === 'en' ? 'Done!' : 'ပြီးပြီ',
        );
      }).catch(() => {});
    },
    async captureElement() {
      try {
        const element = document.getElementById('capture');
        if (!element) {
          console.error('Element not found');
          return;
        }

        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL('image/png');

        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'screenshot.png';
        link.click();
      } catch (error) {
        console.error('Error capturing element:', error);
      }
    },
    totalVoucherAmount() {
      let total = 0;
      const list = this.betHistoryList;
      for (let i = 0; i < list.length; i += 1) {
        total += parseInt(list[i].total_amount, 10);
      }
      return total;
    },
    totalBingoAmount() {
      let total = 0;
      const list = this.betHistoryList;
      for (let i = 0; i < list.length; i += 1) {
        total += parseInt(list[i].bingo_amount, 10);
      }
      return total;
    },
    setLastHalfMonth() {
      this.dateOptionsThreed[0].label = 'Current Draw';
      this.dateOptionsThreed[0].data = 'current';

      this.dateOptionsThreed[1].label = 'Last Draw';
      this.dateOptionsThreed[1].data = 'last';

      this.params.date = 'current';
    },
    changeType(type) {
      if (type === 'threed') {
        this.setLastHalfMonth();
      } else {
        this.params.date = moment(new Date()).format('l');
        this.params.draw = this.currentDraw();
      }
      this.type = type;
    },
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format('l');
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    async getSlipdata(data) {
      try {
        if (this.type !== 'maung' && this.type !== 'body' && this.type !== '1x2' && this.type !== 'correctScore') {
          const res = await axios.post('vouchers/datas', {
            voucher_id: data.id,
            type: data.type,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
          this.isTwod = data.type === 'twod';
          this.slipId = data.id;
          this.name = data.name;
          this.remark = data.remark;
          this.bet_date = data.type === 'twod'
            ? this.betTime(data.created_at)
            : this.betTime(data.created_at);
          this.datas = res.data.data;
          $('#voucher-history').modal('show');
        } else {
          this.datas = data.team_vouchers;
          this.bingo_amount = data.bingo_amount;
          this.slipId = data.id;
          this.is_result = data.isBet;
          this.type = data.type;
          this.bet_date = this.betTime(data.created_at);
          $('#voucher-history').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHistory() {
      try {
        this.isSearch = true;
        let res;
        if (this.type === 'twod' || this.type === 'threed') {
          res = await axios.post('/vouchers/datas/all', {
            draw: this.params.draw,
            date: this.params.date,
            search: this.searchKeyword,
            isBingo: this.isBingo,
            type: this.type,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
        } else {
          res = await axios.post('/fb-vouchers-history', {
            draw_date: this.params.date,
            type: this.type,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
        }

        this.betHistory = res.data.data;
        this.isSearch = false;
      } catch (error) {
        console.log(error);
        this.isSearch = false;
      }
    },
    betDate(time) {
      return moment(time).format('l');
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    closeModal() {
      $('#voucher-history').modal('hide');
    },
    currentDraw() {
      const currentHour = new Date().getHours();
      if (currentHour < 12) {
        return '12:00';
      }
      return '4:30';
    },
  },
  watch: {
    searchKeyword() {
      if (this.searchKeyword === '') {
        this.fetchHistory();
      }
    },
    type() {
      if (this.type !== 'threed') {
        this.params.date = moment(new Date()).format('l');
        this.params.draw = this.currentDraw();
      } else {
        this.setLastHalfMonth();
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.params.date = moment(new Date()).format('l');
    this.params.draw = this.currentDraw();
    this.fetchHistory();
    this.setOneMonth();
  },
};
</script>
<style scoped>
.bhist-page {
  min-height: 100vh;
  padding: 1rem 0.65rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.bhist-inner {
  margin: 0 auto;
  max-width: 52rem;
}

.bhist-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 0.85rem;
  overflow: hidden;
}

.bhist-card--header {
  overflow: visible;
  padding-bottom: 0.85rem;
  position: relative;
  z-index: 40;
}

.bhist-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.5rem;
  text-transform: uppercase;
}

.bhist-segments {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  padding: 0 0.85rem 0.85rem;
}

.bhist-seg {
  -webkit-tap-highlight-color: transparent;
  background: #252830;
  border: 1px solid transparent;
  border-radius: 999px;
  color: #b4bcc8;
  cursor: pointer;
  flex: 1 1 auto;
  font-size: 0.68rem;
  font-weight: 600;
  min-width: 4.25rem;
  padding: 0.5rem 0.5rem;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.bhist-seg--active {
  background: rgba(250, 230, 60, 0.2);
  border-color: rgba(250, 230, 60, 0.55);
  color: #faf3a8;
}

.bhist-filters {
  padding: 0 0.85rem 0.35rem;
}

.bhist-filters-row {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.bhist-select-wrap {
  flex: 1 1 10rem;
  min-width: 0;
}

.bhist-select-wrap--draw {
  flex: 1 1 7rem;
}

.bhist-draw-field {
  align-items: center;
  display: flex;
  flex: 1 1 12rem;
  gap: 0.5rem;
  min-width: 0;
}

.bhist-draw-label {
  color: #8b95a8;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.bhist-draw-field .bhist-select {
  flex: 1;
  min-width: 0;
}

.bhist-search {
  -webkit-tap-highlight-color: transparent;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  transition: filter 0.15s ease;
}

.bhist-search:active {
  filter: brightness(1.06);
}

.bhist-bingo {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  margin-top: 0.65rem;
  padding-top: 0.35rem;
}

.bhist-bingo__check {
  margin: 0 !important;
}

.bhist-bingo__check >>> .custom-control-label::before,
.bhist-bingo__check >>> .custom-control-label::after {
  top: 0.1rem;
}

.bhist-bingo__label {
  color: #c5cad6;
  font-size: 0.8rem;
  font-weight: 600;
}

.bhist-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.bhist-loading {
  align-items: center;
  color: #8b95a8;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  justify-content: center;
  min-height: 10rem;
  padding: 2rem 1rem;
}

.bhist-loading__spin {
  padding: 0 !important;
}

.bhist-loading__text {
  font-size: 0.875rem;
}

.bhist-empty {
  color: #8b95a8;
  font-size: 0.875rem;
  padding: 2.25rem 1.25rem;
  text-align: center;
}

.bhist-table {
  color: #e8eaef !important;
  margin-bottom: 0;
}

.bhist-table >>> .thead-light th {
  background: #252830 !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #8b95a8 !important;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

.bhist-table >>> .list {
  background: #1d1f26 !important;
}

.bhist-table >>> .list th {
  border-color: rgba(255, 255, 255, 0.06) !important;
  vertical-align: middle;
}

.bhist-row {
  cursor: pointer;
  transition: background 0.12s ease;
}

.bhist-row:hover {
  background: rgba(92, 152, 255, 0.06) !important;
}

.bhist-row:active {
  background: rgba(92, 152, 255, 0.1) !important;
}

.bhist-cell-muted {
  color: #c5cad6 !important;
}

.bhist-totals-row {
  background: rgba(0, 0, 0, 0.2) !important;
}

.bhist-total-label {
  color: #e8eaef !important;
}

.bhist-total-bingo {
  color: #ff6b6b;
}

.bhist-total-amt {
  color: #6bcf7f;
}

.bhist-select-wrap >>> .vs__dropdown-toggle,
.bhist-draw-field >>> .vs__dropdown-toggle {
  background: #252830 !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 0.15rem 0.35rem;
}

.bhist-select-wrap >>> .vs__selected,
.bhist-select-wrap >>> .vs__search,
.bhist-draw-field >>> .vs__selected,
.bhist-draw-field >>> .vs__search {
  color: #f0f2f5 !important;
}

.bhist-card--table >>> .select-containers {
  height: auto;
}

.bhist-modal-dialog {
  margin: 1.15rem auto;
  max-width: 26.5rem;
  padding: 0 0.65rem;
}

.bhist-modal-content {
  background: #ffffff !important;
  border: 1px solid #e6ebf2 !important;
  border-radius: 18px !important;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.16);
  color: #1e293b;
  overflow: hidden;
}

.bhist-modal-toolbar {
  align-items: center;
  background: linear-gradient(180deg, #fbfcfe 0%, #f4f7fb 100%);
  border-bottom: 1px solid #e8edf3;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  padding: 0.7rem 0.8rem;
}

.bhist-modal-title {
  color: #0f172a;
  flex: 1;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.2;
  margin: 0;
  min-width: 0;
  text-align: center;
}

.bhist-modal-capture {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: #ffffff;
  border: 1px solid #d7e2f3;
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #3b6fd9;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 600;
  gap: 0.35rem;
  height: 2.15rem;
  justify-content: center;
  padding: 0 0.75rem 0 0.65rem;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.bhist-modal-capture:hover,
.bhist-modal-capture:focus {
  background: #eef4ff;
  border-color: #b7cdf5;
  box-shadow: 0 0 0 3px rgba(92, 152, 255, 0.16);
  outline: none;
}

.bhist-modal-capture:active {
  background: #e4edff;
}

.bhist-modal-capture-label {
  line-height: 1;
}

.bhist-modal-close {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 1.2rem;
  font-weight: 600;
  height: 2.15rem;
  justify-content: center;
  line-height: 1;
  padding: 0;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  width: 2.15rem;
}

.bhist-modal-close:hover,
.bhist-modal-close:focus {
  background: #fee2e2;
  border-color: #fecaca;
  color: #dc2626;
  outline: none;
}

.bhist-modal-close:active {
  background: #fecaca;
}

.bhist-modal-body {
  background: #ffffff;
  color: #1e293b;
  max-height: min(72vh, 36rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.bhist-modal-content >>> .card-upgrade,
.bhist-modal-content >>> .card-body {
  background: #ffffff;
  color: #1e293b;
}

@media (max-width: 576px) {
  .bhist-seg {
    font-size: 0.62rem;
    min-width: 0;
    padding: 0.45rem 0.35rem;
  }

  .bhist-modal-capture-label {
    display: none;
  }

  .bhist-modal-capture {
    padding: 0;
    width: 2.15rem;
  }
}
</style>
